/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiKeys } from '../models/api-keys';
import { apiKeysCreateKey } from '../fn/api-keys/api-keys-create-key';
import { ApiKeysCreateKey$Params } from '../fn/api-keys/api-keys-create-key';
import { apiKeysDelete } from '../fn/api-keys/api-keys-delete';
import { ApiKeysDelete$Params } from '../fn/api-keys/api-keys-delete';
import { apiKeysGetAllKeys } from '../fn/api-keys/api-keys-get-all-keys';
import { ApiKeysGetAllKeys$Params } from '../fn/api-keys/api-keys-get-all-keys';

@Injectable({ providedIn: 'root' })
export class ApiKeysService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiKeysGetAllKeys()` */
  static readonly ApiKeysGetAllKeysPath = '/api/ApiKeys';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeysGetAllKeys()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeysGetAllKeys$Response(params?: ApiKeysGetAllKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiKeys>>> {
    return apiKeysGetAllKeys(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeysGetAllKeys$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeysGetAllKeys(params?: ApiKeysGetAllKeys$Params, context?: HttpContext): Observable<Array<ApiKeys>> {
    return this.apiKeysGetAllKeys$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ApiKeys>>): Array<ApiKeys> => r.body)
    );
  }

  /** Path part for operation `apiKeysCreateKey()` */
  static readonly ApiKeysCreateKeyPath = '/api/ApiKeys';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeysCreateKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiKeysCreateKey$Response(params: ApiKeysCreateKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeys>> {
    return apiKeysCreateKey(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeysCreateKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiKeysCreateKey(params: ApiKeysCreateKey$Params, context?: HttpContext): Observable<ApiKeys> {
    return this.apiKeysCreateKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiKeys>): ApiKeys => r.body)
    );
  }

  /** Path part for operation `apiKeysDelete()` */
  static readonly ApiKeysDeletePath = '/api/ApiKeys/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeysDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeysDelete$Response(params: ApiKeysDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeys>> {
    return apiKeysDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeysDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeysDelete(params: ApiKeysDelete$Params, context?: HttpContext): Observable<ApiKeys> {
    return this.apiKeysDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiKeys>): ApiKeys => r.body)
    );
  }

}
